import Conditional from 'decorators/conditional';
import Desktop from './index.desktop';
import Mobile from './index.mobile';

export default Conditional({
  default: Desktop,
  desktop: Desktop,
  mobile: Mobile,
});
